import { PERMISSION } from "../constants";
import { APP_PATH } from "constants/path";
import React from "react";
import { lazyRetry } from "utils/route";

import { CarOutlined } from "@ant-design/icons";

const SuperCarList = React.lazy(() =>
	lazyRetry(() => import("../features/supercar/SuperCarList")),
);
const SuperCarDetail = React.lazy(() =>
	lazyRetry(() => import("../features/supercar/SuperCarDetail")),
);
const SuperCarCreate = React.lazy(() =>
	lazyRetry(() => import("../features/supercar/SuperCarCreate")),
);

const supercarRoutes = [
	// Supercars
	{
		label: "Supercars",
		path: APP_PATH.supercars,
		key: "supercars",
		icon: <CarOutlined />,
		children: [],
		component: <SuperCarList />,
		permissions: [PERMISSION.CAR.VIEW],
	},
	{
		label: "Car Detail",
		path: `${APP_PATH.supercars}/:id`,
		key: "cars",
		icon: <CarOutlined />,
		children: [],
		component: <SuperCarDetail />,
		hidden: true,
		permissions: [PERMISSION.CAR.VIEW],
	},
	{
		label: "Create car",
		path: APP_PATH.supercarCreate,
		key: "supercar create",
		icon: <CarOutlined />,
		children: [],
		component: <SuperCarCreate />,
		hidden: true,
		permissions: [PERMISSION.CAR.UPDATE],
	},
];

export default supercarRoutes;
